<template>
	<div>
		<div class="slideout-toolbar-top" v-show="showfilters">
			<div class="row">
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t("programme") }}</label>
						<select class="form-control" v-model="filters.programme">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="programme in $config.getValue('programmes')"
							:key="programme.Id"
							:value="programme"
							>{{ programme.Name}}
							</option>
						</select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t("year") }}</label>
						<select class="form-control" v-model="filters.year">
							<option :value="null">{{ $t("any") }}</option>
							<template v-if="filters.programme">
								<option
								v-for="year in parseInt(filters.programme.CourseLengthYears)"
								:key="year"
								:value="year"
								>{{ year }}
								</option>
								<option :value="parseInt(filters.programme.CourseLengthYears) + 1">{{ $t('graduated') }}</option>
							</template>
						</select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t("group") }}</label>
						<select class="form-control" v-model="filters.group">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="(name, id) in $config.getValue('groups')"
							:key="id"
							:value="id"
							>{{ name }}
							</option>
						</select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t("firm") }}</label>
						<select class="form-control" v-model="filters.firm">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="(name, id) in $config.getValue('firms')"
							:key="id"
							:value="id"
							>{{ name }}
							</option>
						</select>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('from') }}</label>
						<input
							type="date"
							v-model="filters.date_from"
							class="form-control"
						>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('to') }}</label>
						<input
							type="date"
							v-model="filters.date_to"
							class="form-control"
						>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<button class="btn btn-primary float-right" @click="updateFilters()">{{ $t('update') }}</button>
				</div>
			</div>
		</div>
		<div v-show="!showfilters" class="clearfix mb-2">
			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<select class="form-control" v-model="reportid" @change="changeReportConfig()">
							<option
								v-for="config in reportconfigs"
								:key="config.id"
								:value="config.id"
								>{{ config.title }}
							</option>
						</select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<select class="form-control" v-model="termtarget" @change="changeTargets()">
							<option :value="null">{{$t('targets')}}</option>
							<template v-for="(term, index) in $config.getValue('schoolterms')">
							<option
								v-if="(!filters.programme) || (term.programme_id == filters.programme.Id)"
								:key="index"
								:value="term"
								>{{ term.programme_name }} {{ term.schoolterm_title }}
							</option>
							</template>
						</select>
					</div>
				</div>
				<div class="col-md-3">
				 	<div class="float-right">
				 		<button class="btn btn-secondary ml-2" @click="downloadReport()" v-if="this.reportid"><b-icon icon="download"></b-icon></button>
						<button class="btn btn-primary float-right ml-2" @click="showfilters = true">{{ $t('filter') }}</button>
					</div>
				</div>
			</div>
		</div>
		<Aggregated
			ref="reportview"
			v-if="loadedconfig"
			:reportid="reportid"
			:filters="filters"
			:loadedconfig="loadedconfig"
		/>
	</div>
</template>

<script>
import Aggregated from "../../components/Reports/Aggregated";

export default {
	components: {
		Aggregated
	},
	data() {
		return {
			showfilters: false ,
			reportid: null ,
			reportconfigs: [] ,
			filters: {
				programme: null,
				year: null ,
				group: null ,
				firm: null ,
				date_from: null ,
				date_to: null ,
				session_type: [] ,
				locked: []
			},
			termtarget: null,
			loadedconfig: null
		};
	},
	mounted() {
		this.getAvailableConfigs()
		if(this.$route.params.reportid){
			this.reportid = this.$route.params.reportid;
			if(this.$route.params.programme){
				var programmes = this.$config.getValue('programmes');
				for(var pid in programmes){
					if(programmes[pid].Id == this.$route.params.programme){
						this.filters.programme = programmes[pid];
					}
				}
			}
			if(this.$route.params.year) {
				this.filters.year = this.$route.params.year;
			}
			if(this.$route.params.group){
				this.filters.group = this.$route.params.group;
			}
			this.getReportConfig(null);
		} else {
			this.showfilters = true;
		}
	},
	methods: {
		unableToGetSettings() {
			const self = this;
			this.$store.commit("openDialog" , {
				title: this.$t('oops'),
				content: this.$t('unable-to-get-report-settings'),
				confirmCallBack: function(){
					self.$router.replace('/');
				}
			});
		},
		getAvailableConfigs() {
			this.$cfetch(`${this.$settings.APIBaseURL}/reporting/list`, {
				data: {
					all: true,
					reportconfig_type: 'standard'
				}
			})
			.then(json => {
				if (json.status === "SUCCESS") {
					this.reportconfigs = json.reportconfigs
				}
			});
		},
		changeTargets() {
			if(this.termtarget){
				this.$refs.reportview.programme = this.termtarget.programme_id;
				this.$refs.reportview.year = this.termtarget.schoolyear_id;
				this.$refs.reportview.term = this.termtarget.schoolterm_id;
				this.$refs.reportview.refreshTargets();
				//this.$refs.reportview.refreshReportData();
				//this.changeReportConfig()
			}
		},
		updateFilters() {
			this.showfilters = false;
			if(this.loadedconfig){
				this.$refs.reportview.refreshReportData();
			}
		},
		changeReportConfig() {
			if(this.reportid){
				if(this.loadedconfig){
					this.getReportConfig();
				} else {
					this.getReportConfig();
				}
			}
		},
		getReportConfig(){
			if(!this.$UserSession.hasPriv.call(this, "REPORT_ALLSTUDENTS")){
				this.unableToGetSettings();
				return false;
			}

			this.$store.commit("showBlockingSpinner");
			const data = {
				programme_id: (this.filters.programme?this.filters.programme.Id:null) ,
				year: this.filters.year
			};
			/*
			if(this.$UserSession.hasPriv('REPORT_ALLSTUDENTS')){
				if(this.studentid) {
					data.student_id = this.studentid;
				} else {
					return false;
				}
			}
			*/

			this.$cfetch(`${this.$settings.APIBaseURL}/reporting/report/${this.reportid}`, {
				cache: false,
				data
			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status === "SUCCESS") {
					this.$log.info.call(this, "Report config loaded");
					if('filters' in json.result){
						Object.assign(this.filters, json.result.filters, this.filters);
					}
					//this.loadedconfig = json.result;
					var loadedconfig = {
						teacher: json.result.teacher,
						cols: []
					};
					var datapoint = null;
					var fieldobj = null;
					for(var row in json.result.grid){
						for(var col in json.result.grid[row]){
							for(var field in json.result.grid[row][col].fields){
								if('data' in json.result.grid[row][col].fields[field] && json.result.grid[row][col].fields[field].data){
									if(Array.isArray(json.result.grid[row][col].fields[field].data)){
										for(var item in json.result.grid[row][col].fields[field].data){
											fieldobj = json.result.grid[row][col].fields[field].data[item];
											datapoint = json.result.grid[row][col].fields[field].data[item].data.split('.');
											fieldobj['reportdataelement'] = datapoint[0];
											fieldobj['reportdataelementproperty'] = datapoint[1];
											fieldobj['caption'] = json.result.grid[row][col].fields[field]['caption'] + ' ' + fieldobj['caption']
											loadedconfig.cols.push(fieldobj);
										}
									} else {
										datapoint = json.result.grid[row][col].fields[field].data.split('.');
										if(datapoint.length == 2 && datapoint[1] != 'items'){
											json.result.grid[row][col].fields[field]['reportdataelement'] = datapoint[0];
											json.result.grid[row][col].fields[field]['reportdataelementproperty'] = datapoint[1];
											loadedconfig.cols.push(json.result.grid[row][col].fields[field]);
										}
									}
								}
							}
						}
					}
					this.loadedconfig = loadedconfig;
				} else {
					this.$log.error.call(this, "Could not fetch report settings");
					this.unableToGetSettings();
				}
			})
			.catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
				this.unableToGetSettings();
			});
		} ,
		downloadReport() {
			let body = {
				username: this.$UserSession.getValue.call(this, "username"),
				authToken: this.$UserSession.getValue.call(this, "authToken"),
				filters: JSON.stringify(this.$refs.reportview.getCleanedFilters()),
				selecttopic: this.reportid
			};

			const url = `${this.$settings.APIBaseURL}/reporting/downloadaggregated?` + new URLSearchParams(body).toString();
			window.open(url);
		},

	}
};
</script>
